import styles from './Skeleton.module.css';

export const Skeleton = ({
  width = '100%',
  height = '16px',
  label = 'Loading',
}: {
  width?: string;
  height?: string;
  label?: string;
}) => (
  <span
    className={styles['skeleton']}
    style={{ inlineSize: width, blockSize: height }}
    role="status"
    aria-label={label}
  />
);
